import { Component, OnInit, Input } from '@angular/core';
import {  FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'form-error',
  template: `<div *ngIf="control?.invalid && (control?.dirty || control?.touched)"
 class="form-error">
  <div *ngFor="let err of errors | keys">
    <div *ngIf="control.errors[err.key]">
      <p>{{err.value}}</p>
    </div>
  </div>
</div>
`,
  styles: [``]
})
export class FormErrorComponent implements OnInit {
  @Input() control: FormControl;
  @Input() errors: any;
  defaultErrors = {
    required: "O preenchimento desse campo Ã© obrigatÃ³rio",
    minlength: "Valor informado muito baixo",
    email: "Digite um e-mail vÃ¡lido"
  };

  constructor() {
  }

  ngOnInit() {
    this.errors = Object.assign(this.defaultErrors, this.errors || {})
  }

}
